/* global axios */
import ApiClient from './ApiClient';

class RemarketingSequencesAPI extends ApiClient {
  constructor() {
    super('remarketing_sequences', { accountScoped: true });
  }
}

class RemarketingEnrollmentsAPI extends ApiClient {
  constructor() {
    super('remarketing_enrollments', { accountScoped: true });
  }

  stop(enrollmentId) {
    return axios.post(`${this.url}/${enrollmentId}/stop`);
  }

  enroll({ conversationId, sequenceId }) {
    return axios.post(this.url, {
      conversation_id: conversationId,
      remarketing_sequence_id: sequenceId,
    });
  }
}

class RemarketingUploadsAPI extends ApiClient {
  constructor() {
    super('remarketing_direct_uploads', { accountScoped: true });
  }

  upload(file, onProgress) {
    const form = new FormData();
    form.append('file', file);
    return axios.post(this.url, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: e => {
        if (onProgress && e.total) {
          onProgress(Math.round((e.loaded * 100) / e.total));
        }
      },
    });
  }
}

class RemarketingTemplatesAPI extends ApiClient {
  constructor() {
    super('remarketing_templates', { accountScoped: true });
  }
}

class RemarketingDashboardAPI extends ApiClient {
  constructor() {
    super('remarketing_dashboard', { accountScoped: true });
  }
}

export const remarketingSequencesAPI = new RemarketingSequencesAPI();
export const remarketingEnrollmentsAPI = new RemarketingEnrollmentsAPI();
export const remarketingUploadsAPI = new RemarketingUploadsAPI();
export const remarketingTemplatesAPI = new RemarketingTemplatesAPI();
export const remarketingDashboardAPI = new RemarketingDashboardAPI();
